import logo from '../images/logo-saladillo.svg'
import logoDark from '../images/logo-saladillo-dark.png'
import { useTranslation } from "react-i18next";
import { Typography, Box, List, Grid, Toolbar, CssBaseline, ThemeProvider, IconButton, Tooltip } from '@mui/material'
import MuiDrawer from '@mui/material/Drawer'
import AdminNavItems from '../Administrator/NavItems/AdminNavItems'
import ClientNavItems from '../Client/NavItems/ClientNavItems'
import styles from './mainLayout.module.css';
import { useThemeContext } from '../../theme/ThemeContext'
import React, { useState } from 'react';
import { ChevronLeft, ChevronRight } from '@mui/icons-material'
import { styled, Theme, CSSObject } from '@mui/material/styles';
import MuiAppBar, { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar';
// import { ChangeLanguageButton } from "./ChangeLanguageButton";
import { DarkModeSwitch } from "./DarkModeSwitch";
import UserData from './UserData';
import UserMenu from './UserMenu';
import StaffNavItems from '../Staff/NavItems/StaffNavItems';
import HeadSalesNavItems from '../HeadSales/NavItems/HeadSalesNavItems';
import VendorNavItems from '../Vendor/NavItems/VendortNavItems';
import ManagerNavItems from '../Manager/NavItems/ManagerNavItems';

export const PageOptions = () => {
  const { theme } = useThemeContext()
  return (
    <div style={{ paddingLeft: theme.spacing(2), paddingRight: theme.spacing(2) }}>
      {/*<ChangeLanguageButton />  Se quita opcion. Solicitado por F.May - 06/2024 */}
      <DarkModeSwitch />
    </div>
  )
}


interface AppBarProps extends MuiAppBarProps {
  open?: boolean;
}

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})<AppBarProps>(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  width: `calc(100% - ${theme.spacing(8)} - 1px)`,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: `var(--menu-width)`,
    width: `calc(100% - var(--menu-width))`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 1),
  justifyContent: 'flex-end',
}));


const openedMixin = (theme: Theme): CSSObject => ({
  overflowX: 'hidden',
  width: `var(--menu-width)`,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  })
});

const closedMixin = (theme: Theme): CSSObject => ({
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  })
});

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    width: `var(--menu-width)`,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    ...(open && {
      ...openedMixin(theme),
      '& .MuiDrawer-paper': openedMixin(theme),
    }),
    ...(!open && {
      ...closedMixin(theme),
      '& .MuiDrawer-paper': closedMixin(theme),
    }),
  }),
);


interface NavMenuProps {
  children?: React.ReactNode;
}

export const NavMenu: React.FC<NavMenuProps> = (props) => {
  const { t } = useTranslation(["menu", "login"]);
  const { theme, darkModeEnabled } = useThemeContext()
  const [open, setOpen] = useState(true);

  const handleDrawer = () => {
    setOpen(!open);
  };

  return (

    <ThemeProvider theme={theme}>
      <CssBaseline />

      <AppBar open={open}
        position="fixed" sx={{
          bgcolor: theme.palette.info.main,
          zIndex: 99
        }} elevation={0}>

        <Grid container className={styles.header} wrap="nowrap">
          <UserData />
          <Toolbar>
          </Toolbar>
          <Box display="flex" flexDirection="row" alignItems="center">
            <PageOptions />
            <UserMenu />
          </Box>
        </Grid>
      </AppBar>
      <Drawer variant="permanent" open={open}>
        <DrawerHeader>
          <Tooltip title={open ? t("hideMenu") : t("showMenu")}>
            <IconButton sx={{ color: theme.typography.caption.color }} onClick={handleDrawer}>
              {!open ? <ChevronRight /> : <ChevronLeft />}
            </IconButton>
          </Tooltip>
        </DrawerHeader>
        <Box className={styles.drawerToolbar} sx={{ display: "flex", opacity: open ? 1 : 0, justifyContent: "center", alignItems: "center" }}>
          <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
            <img alt={process.env.REACT_APP_NOT_SHOW_LOGO ? "":"Industrias Saladillo"} height="60%" src={process.env.REACT_APP_NOT_SHOW_LOGO ? "" : darkModeEnabled ? logoDark : logo} />
          </Box>
          <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
            <Typography variant="h5" color={theme.palette.primary.main} noWrap fontWeight="medium" >{t('portal', { ns: 'login' })}</Typography>
          </Box>
        </Box>

        <List sx={{ marginBottom: "30px", marginX: open ? "20px" : 0 }}>
          <AdminNavItems open={open} />
          <ClientNavItems open={open} />
          <VendorNavItems open={open} />
          <HeadSalesNavItems open={open} />
          <ManagerNavItems open={open} />
          <StaffNavItems open={open} />
        </List>
      </Drawer>
      {props.children}
    </ThemeProvider>
  );
}

export default NavMenu